import {bus} from "@/event-bus";

const HelperFunctions = {
    data() {
        return {
            criteriaChanged: false,
            authorized: true,
            carriers: [],
            indeterminateCarriers: false,
            selectedCarriers: [],
            selectAllCarriers: false,
            error: '',
            query_args: '',
            showAlert: false,
            visibleFields: [],
            money: {
                thousands: ',',
                precision: 0,
                masked: false
            },
            agency: [],
        }
    },
    props: {
        buttonText: { type: String },
        agencyId: {type: String},
        apiKey: {type: String},
        searchType: {type: String},
        resultsHeight: {type: String},
        searchParams: {type: String},
    },
    mounted() {

        if (this.agencyId) {
            this.fetchAgencyName().catch(error => {
                console.error(error)
            })
        }


        document.addEventListener("mouseup", () => {
            this.showAlert = false
        })

    },
    methods: {

        async fetchCarriers() {
            const ms = Date.now()
            const params = '?agency_id=' + this.agencyId + '&searchType=' + this.searchType + '&api_key=' + this.apiKey + '&cache_buster=' + ms + '&site=' + window.location.href
            this.carriers = await fetch(this.$hostname + '/cm_api/cm/v1/agency_carriers' + params)
                .then(async res => {
                    if (res.status === 403) {
                        const json = await res.json();
                        this.error = json.message
                        this.showAlert = true
                        this.authorized = false
                        throw new Error('403 is unacceptable for me!')
                    } else {
                        return res.json()
                    }
                })
                .then(carriers => carriers)
            if (!this.dontPreselectCarriers) {
                for (let key in this.carriers) {
                    this.selectedCarriers.push(this.carriers[key].id)
                }
                this.selectAllCarriers = true
                this.indeterminateCarriers = true
                this.isBusy = !this.isBusy
            }
            bus.$emit("update-carriers", this.carriers)
        },

        async fetchAgencyName() {
            this.agency = await fetch(this.$hostname + '/cm_api/wp/v2/bga/' + this.agencyId + '/').then(res => {
                    return res.json()
                }).then(agency => {
                    bus.$emit("update-agency-name",  agency.title.rendered)
                })

        },

        getCarrierNameByID(value) {
            if (!value)
                return
            return this.carriers.filter(carrier => carrier.id == value).map(carrier => carrier.name)[0]
        },

        listLinks(value, objProp) {
            let output = ''
            let addSpaces = ''

            let iterations = Object.values(value).length
            for (const v of Object.values(value)) {
                // output += '<a href="'+v[objProp].url+'">'+v[objProp].title+'</a>\n'
                if (--iterations)
                    addSpaces = ', '
                if (objProp)
                    output += v[objProp].url + addSpaces
            }
            return output.split(',').map(e => e.trim()).filter(e => e).join(', ')
        },


        convertDate(value) {
            let date = new Date(value)
            return date.toLocaleDateString("en-US")
        },

        select(selected, model, data, value, indeterminate) {
            this[selected] = [];
            this[indeterminate] = false
            if (model) {
                for (let i in data) {
                    this[selected].push(data[i][value])
                }
                this[indeterminate] = true
            }
        },

        buildVisibleFields(keys) {
            this.visibleFields = []
            keys.forEach(k => {
                this.visibleFields.push(...this.fields.filter(field => field.key === k))
            })
        },

        toText(html) {
            const div = document.createElement('div');
            div.innerHTML = html
            return div.textContent
        },

        scrollToTop() {
            window.scrollTo(0, 0)
        },

        excelTermsOfUse() {
            return 'While significant efforts were made to ensure accuracy ' + this.agencyName + ', and the carriers represented in this website application assume no responsibility or liability for any errors or omissions in the content provided. The information contained is provided with no guarantees of completeness, accuracy, or currency and without warranties of any kind and users should consult carrier documentation and/or carrier personnel before taking any action. By continuing to use this software, you acknowledge understanding of this disclaimer and agree to be bound by the Terms of Use found at https://carriermatrix.com/web-application-terms-and-conditions-of-use/. FOR SIMPLICITY FINANCIAL MARKETING HOLDINGS INC. AFFILIATES USE ONLY. NOT FOR PRODUCER OR CONSUMER USE.'
        },

        cleanCellContent(content, extractLinks = false) {
            if (content === null || content === undefined) return extractLinks ? { text: "", links: [] } : "";
            if (typeof content !== 'string') {
                return extractLinks ? { text: String(content), links: [] } : String(content);
            }

            // Extract links before removing HTML tags
            const links = [];
            const linkRegex = /<a\s+(?:[^>]*?\s+)?href=["']([^"']*)["'][^>]*>(.*?)<\/a>/gi;
            let match;
            
            // Find all links
            while ((match = linkRegex.exec(content)) !== null) {
                links.push({ url: match[1], text: match[2] });
            }
            
            // Replace <p> tags with new lines, preserving content structure
            let cleaned = content.replace(/<p>(.*?)<\/p>/g, "$1\n");
            
            // Remove unwanted HTML tags (e.g., <p><br></p>)
            cleaned = cleaned.replace(/<p><br><\/p>/g, "\n");
            
            // Replace <br> tags with new lines
            cleaned = cleaned.replace(/<br\s*\/?>/g, "\n");
            
            // Remove all HTML tags
            cleaned = cleaned.replace(/<\/?[^>]+(>|$)/g, "");
            
            // Decode HTML entities (e.g., &amp; -> &)
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = cleaned;
            cleaned = tempDiv.textContent || tempDiv.innerText || "";
            
            // Remove extra whitespace and normalize spaces, but preserve line breaks
            cleaned = cleaned.replace(/[ \t]+/g, " ");
            cleaned = cleaned.replace(/\n+/g, "\n").trim();
            
            // For hyperlink creation, return both cleaned text and link information
            if (extractLinks) {
                return {
                    text: cleaned,
                    links: links
                };
            }
            
            return cleaned;
        },

    },
    computed: {
        appVersion() {
            return JSON.parse(unescape(process.env.PACKAGE_JSON || '%7Bversion%3A0%7D')).version;
        }
    },
    watch: {

    },
}

export default HelperFunctions
